import { GetGroupPurchaseRespone, GiftCardResponse } from "api"
import {
  Dispatch,
  FC,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react"

type Steps = "otp" | "failure"

export type OtpContextType = {
  setTotalTimeoutInSeconds: Dispatch<SetStateAction<number>>
  totalTimeoutInSeconds: number
  setAccessToken: Dispatch<SetStateAction<string>>
  accessToken: string
  phoneNumber: string
  setPhoneNumber: Dispatch<SetStateAction<string>>
  giftCards: GiftCardResponse[]
  setGiftCards: Dispatch<SetStateAction<any>>
  groupPurchases: GetGroupPurchaseRespone[]
  setGroupPurchases: Dispatch<SetStateAction<any>>
  step: Steps
  setStep: Dispatch<SetStateAction<Steps>>
}

export const OtpContext = createContext<OtpContextType>(null)

export const OtpContextProvider: FC = ({ children }) => {
  const [totalTimeoutInSeconds, setTotalTimeoutInSeconds] = useState(0)
  const [accessToken, setAccessToken] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [giftCards, setGiftCards] = useState(null)
  const [groupPurchases, setGroupPurchases] = useState(null)
  const [step, setStep] = useState<Steps>("otp")

  return (
    <OtpContext.Provider
      value={{
        totalTimeoutInSeconds,
        setTotalTimeoutInSeconds,
        accessToken,
        setAccessToken,
        setPhoneNumber,
        phoneNumber,
        giftCards,
        setGiftCards,
        groupPurchases,
        setGroupPurchases,
        step,
        setStep,
      }}
    >
      {children}
    </OtpContext.Provider>
  )
}

export const useOtpContext = () => useContext(OtpContext)
